<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
        <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>Notifications</v-toolbar-title>
    </v-toolbar>

	    <div class="hasToolbar" v-scroll="onScroll">
	    	
	    	<v-list three-line nopadding>
	    		
	    		<div v-for="(item, index) in listItemObject.items" :key="index">
	    			<v-list-tile @click="fn_notificationDetail(item)">

              <v-list-tile-content>
                  <v-list-tile-title>{{item.NotificationTitle}}</v-list-tile-title>
                  <v-list-tile-sub-title class="mt-1">{{item.CompletedOn | moment("DD-MMM-YYYY hh:mm a")}}</v-list-tile-sub-title>
              </v-list-tile-content>

            </v-list-tile>

	          <v-divider v-if="listItemObject.items.length-1!=index"></v-divider>

	    		</div>

	    	</v-list>

        <div class="pa-4 center-align" v-if="loadMore">
          <v-progress-circular indeterminate :width="2" color="primary"></v-progress-circular>
        </div>

	    	<div v-if="!listItemObject.ItemCount && !loadMore" class="display_msg">There are no notifications!</div>

        <div class="pa-4 center-align" v-if="error && !loadMore">
            <div>Something went wrong!</div>
            <v-btn class="mt-3" outline flat capitalize color="primary" @click="fn_getToken">Retry</v-btn>
        </div>
	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				listItemObject:{"items":[], "ItemCount":0},
        startIndex:0,
        loadMore:false,
        error:false
			}
		},
		methods:{

      onScroll (event) {
        var element = event.target;
        if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
        {
            console.log('scrolled');
            if(this.listItemObject.items.length < this.listItemObject.ItemCount){
              this.fn_getToken();
            }
        }
      },

      fn_notificationDetail: function(item){
        this.$router.push({path:"/notifications/" + this.$root.CurrentBusiness.BusinessID + "/" + item.UserNotificationID});
      },

			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_getToken: function(){
				// this.showLoading("Please wait...");
        if(!navigator.onLine){
          this.showToast('Internet not available');
          return;
        }
        
        this.error = false;
        this.loadMore = true;

				this.$root.fn_getAuthToken(token => {
          if(token != 'error'){
            this.fn_items(token);
          }
        });
			},

			fn_items: function(token){
				if(!navigator.onLine){
          this.showToast('Internet not available');
          return;
        }
        
        let self = this;
        let dataObj = {};
        dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
        dataObj.token = token;
        dataObj.offset = this.startIndex;
        dataObj.limit = 10;

        this.getServerData('GetNotifications', dataObj, 
          {
              onSuccess: function(response){
                console.log(response);
                let responseJson = JSON.parse(response);
                self.listItemObject.ItemCount = responseJson.ItemCount;
                for(let i in responseJson.UserNotifications){
                  self.listItemObject.items.push(responseJson.UserNotifications[i]);
                }
                self.startIndex = self.listItemObject.items.length;
                self.loadMore = false;
                // self.hideLoading();
              }, 
              onError: function(error){
                  console.log(error);
                  self.loadMore = false;
                  self.error = true;
                  // self.hideLoading();
                  if(typeof JSON.parse(error) == 'object'){
                      let response = JSON.parse(error);
                      self.showToast(response.Message);
                  }
              }, 
          }
        );
			}

			
		},

	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_getToken();
	  	}
	}
</script>


// WEBPACK FOOTER //
// src/components/notification/notifications.vue